
import React from 'react';
import Layout from '@/components/Layout';

const HomePage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Home Page</h1>
        <p className="mt-4">Welcome to our platform.</p>
      </div>
    </Layout>
  );
};

export default HomePage;
